// File: client/src/services/api.js
import axios from 'axios';
                                                                                                                        
const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL+'/api' || 'http://localhost:5000/api',
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
  }
});                                                                                          
                                                         
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});                                                              
                                                                             
export default api;                                                   